export default __webpack_public_path__ + "static/media/VTEX.801a93e9.png";